module.exports = __webpack_public_path__ + "static/media/check.9d55d978.svg";